export default __webpack_public_path__ + "static/media/timeline_02.025c82af.png";